/**
 * Simplest reusable array checker.
 * Will be updated if necessary.
 */

function isNotEmpty(array){
  return array && array.length > 0
}

export { isNotEmpty }
